import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { Button, Form,Icon } from 'semantic-ui-react'
import { FormTitle } from '../../../../commonComponents/FormTitle'
import List from '../../../../commonComponents/List'
import AdditionalDocumentDetails from './additionalDocumentDetailsAGS'
import { CustomLoader } from '../../../../commonComponents/formComponents/loader'
import { TranslateContext } from '../../TranslateContext'
import { useMultipleMerchandiseItem } from '../../../hooks/useMultipleMerchandiseItem'
import { selectTransmissionTypeVal } from '../../../selectors'
import { isLastShipmentState } from '../../util'

const AddtionalDocumentAGS = ({ merchandiseId, invoiceId,invoiceIndex, lineItemIndex,isDisabled,fieldPattern, validateError,initItemsTabValidation,declarationStatus }) => {
  
  const additionalDocList =useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.additionalDoc) || []
  const {isLoading,AddItem,deleteItem,updateItem,saveItem,copyData}=useMultipleMerchandiseItem({tableName:"additionalDoc",invoiceId,merchandiseId});
  const transmissionType=useSelector((state)=>selectTransmissionTypeVal(state))
  const isFormdisabled=(transmissionType=="SUP" && !isLastShipmentState(declarationStatus)) ? false : isDisabled
  
  const renderItem = useCallback(
    (item, addDocIdx) => {
      return (
        <AdditionalDocumentDetails
          key={item.id}
          item={item}
          invoiceIndex={invoiceIndex}
          lineItemIndex={lineItemIndex}
          addDocIdx={addDocIdx}
          isFormdisabled={isFormdisabled}
          updateData={updateItem}
          deleteData={deleteItem}
          saveData={saveItem}
          copyData={copyData}
          fieldPattern={fieldPattern}
          validateError={validateError}
          initItemsTabValidation={initItemsTabValidation}
        />
      )
    },
    [updateItem,deleteItem,saveItem,copyData,isFormdisabled, validateError]
  )

  const translate = React.useContext(TranslateContext).translate

  return (
    <Form.Group className='float-container mb-2'>
      <FormTitle
        title={translate('ADDITIONAL_DOCS', { ns: ['default', 'items', 'header'] })}
      ></FormTitle>
      <List dataSource={additionalDocList} renderItem={renderItem} />

      {isLoading && <CustomLoader />}
      {additionalDocList?.length < 99 && (
        <Button 
        id={`add-additionalDocsAgs-${invoiceId}-${merchandiseId}`}
        basic
        color="blue"
        className="btn-add-item"
        disabled={isFormdisabled} 
        onClick={AddItem} 
        >
          <span><Icon name="add circle" /></span>
          {translate("ADD")}

  </Button>
        
      )}
    </Form.Group>
  )
}

export default React.memo(AddtionalDocumentAGS)
